import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuick from "@/pages/home/components/CategoryQuick";
import HotRow from "@/pages/home/components/HotRow";
import LatestGrid from "@/pages/home/components/LatestGrid";
import TopicShowcase from "@/pages/home/components/TopicShowcase";
import SectionHeading from "@/components/base/SectionHeading";
import LoadingGrid from "@/components/base/LoadingGrid";
import ErrorState from "@/components/base/ErrorState";
import { useAsyncData } from "@/hooks/useAsyncData";

export default function Home() {
  const { loading, error, retry } = useAsyncData(() => true, []);

  return (
    <div className="w-full">
      <HeroCarousel />

      <div className="w-full px-4 md:px-8">
        {/* 分类快捷入口 */}
        <section className="pt-12 md:pt-16">
          <SectionHeading
            icon="ri-apps-2-line"
            title="发现你的兴趣分类"
            subtitle="影视剧、综艺、原创、动漫、纪录片，高清内容一站直达"
          />
          <CategoryQuick />
        </section>

        {error ? (
          <section className="py-16">
            <ErrorState onRetry={retry} />
          </section>
        ) : (
          <>
            {/* 热门推荐 */}
            <section className="pt-12 md:pt-16">
              <SectionHeading
                icon="ri-fire-line"
                title="热门推荐"
                subtitle="口碑与热度双高的精选内容，正在热播"
                to="/category/drama"
                toLabel="更多推荐"
              />
              {loading ? (
                <LoadingGrid count={5} />
              ) : (
                <HotRow />
              )}
            </section>

            {/* 最新更新 */}
            <section className="pt-12 md:pt-16">
              <SectionHeading
                icon="ri-time-line"
                title="最新更新"
                subtitle="每日持续上新，追更不迷路"
              />
              {loading ? <LoadingGrid count={10} /> : <LatestGrid />}
            </section>

            {/* 精选专题 */}
            <section className="pt-12 md:pt-16 pb-14 md:pb-20">
              <SectionHeading
                icon="ri-movie-2-line"
                title="精选专题合集"
                subtitle="按主题成系列推荐，一次看个过瘾"
              />
              {loading ? <LoadingGrid count={4} /> : <TopicShowcase />}
            </section>
          </>
        )}
      </div>
    </div>
  );
}